// src/redux/shipmentSlice.js
import { createSlice } from "@reduxjs/toolkit";

// In-memory initial state (do not persist Files)
const initialState = {
  shipmentId: null,
  categoryId: null,
  pickupAddress: {},
  dropoffAddress: {},
  items: [],
  pickupDate: "",
  pickupTime: "",
  customTime: "",
  urgencyLevel: "",
  po_number: "",
  toTime:"",
};

const shipmentSlice = createSlice({
  name: "shipment",
  initialState,
  reducers: {
    setShipmentField: (state, action) => {
      const { key, value } = action.payload || {};
      if (key && Object.prototype.hasOwnProperty.call(state, key)) {
        state[key] = value;
      }
    },
    setShipmentId: (state, action) => {  // ✅ new action for tracking shipmentId
      state.shipmentId = action.payload;
    },
    setCategoryId: (state, action) => {
      state.categoryId = action.payload;
    },
    setPickupAddress: (state, action) => {
      state.pickupAddress = action.payload;
    },
    setDropoffAddress: (state, action) => {
      state.dropoffAddress = action.payload;
    },
    setItems: (state, action) => {
      state.items = action.payload;
    },
    setPickupDate: (state, action) => {
      state.pickupDate = action.payload;
    },
    setPickupTime: (state, action) => {
      state.pickupTime = action.payload;
    },
    setToTime: (state, action) => {
      state.toTime = action.payload;
    },
    setCustomTime: (state, action) => {
      state.customTime = action.payload;
    },
    setUrgencyLevel: (state, action) => {
      state.urgencyLevel = action.payload;
    },
    setpo_number: (state, action) => {
      state.po_number = action.payload;
    },

    // ✅ Add item and persist
    addItem: (state, action) => {
      state.items.push(action.payload);
    },

    // ✅ Delete item and persist
    deleteItem: (state, action) => {
      state.items.splice(action.payload, 1);
    },
    updateItemQuantity: (state, action) => {
    const { index, quantity } = action.payload;
    if (state.items[index]) {
      state.items[index].quantity = quantity;
    }
  },
    updateItemImage: (state, action) => {
      const { index, preview } = action.payload;
      if (state.items[index]) {
        state.items[index].preview = preview;
      }
    },

    resetShipment: () => ({
      shipmentId: null,
      categoryId: null,
      pickupAddress: {},
      dropoffAddress: {},
      items: [],
      pickupDate: "",
      pickupTime: "",
      customTime: "",
      urgencyLevel: "",
      po_number: "",
    }),

    clearShipment: () => ({
      shipmentId: null,
      categoryId: null,
      pickupAddress: {},
      dropoffAddress: {},
      items: [],
      pickupDate: "",
      pickupTime: "",
      customTime: "",
      urgencyLevel: "",
      po_number: "",
    }),
  },
});

export const {
  setShipmentField,
  setShipmentId, // ✅ export new action
  setCategoryId,
  setPickupAddress,
  setDropoffAddress,
  setPickupDate,
  setPickupTime,
  setCustomTime,
  setUrgencyLevel,
  setpo_number,
  setItems,
  resetShipment,
  addItem,
  deleteItem,
  updateItemQuantity,
  clearShipment,
  updateItemImage,
  setToTime,
} = shipmentSlice.actions;

export default shipmentSlice.reducer;
